import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckboxComponent } from './checkbox.component';
import { CheckboxGroupComponent } from './checkbox-group.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule,
  ],
  declarations: [
    CheckboxComponent,
    CheckboxGroupComponent,
  ],
  exports: [
    CheckboxComponent,
    CheckboxGroupComponent,
  ]
})
export class CheckboxModule {}
